export const CONTRACT_STATUSES = {
    'ACTIVE': 'Active',
    'CANCELLED': 'Cancelled',
    'PENDING': 'Pending',
    'BLOCKED': 'Blocked',
}
